<div [class.disabled]="control.disabled" [class.readonly]="readonly" [class]="wrapperClass + ' text-start d-inline-block'">

  <label [id]="id + '_checkbox'"
         class="custom-checkbox">
    <!-- A real control: role, aria-checked, tab stop, Space and the disabled state
         all come from the platform. It is visually hidden via opacity (never
         display:none, which would take it out of the tab order) and sits exactly
         over .custom-control-indicator, which draws the box. -->
    <input (change)="toggle($event)"
           [attr.aria-disabled]="readonly ? 'true' : null"
           [attr.aria-invalid]="control.invalid && control.touched ? 'true' : null"
           [attr.aria-required]="isRequired ? 'true' : null"
           [checked]="control.value === cbCheckedValue"
           [disabled]="control.disabled"
           [id]="id + '_input'"
           class="custom-control-input"
           type="checkbox">
    <span [class.checked]="control.value === cbCheckedValue"
          [class.fa-check]="control.value == cbCheckedValue"
          [class.ng-invalid]="control.invalid"
          [class.ng-touched]="control.touched"
          aria-hidden="true"
          class="fa custom-control-indicator text-start">
    </span>
    <div [class]="'custom-control-description d-inline-block ' + (labelClass ?? '')">
      <span [innerHTML]="label | safe: 'html'"></span>
      @if ((controlIsRequired$ | async) && showRequiredStar) {
        <em aria-hidden="true" class="d-inline-block">*</em>
      }
    </div>

  </label>
</div>
